<template>
  <div class="flex items-center space-x-2">
    <span class="font-medium text-gray-700">{{ label || `${starRating} Star Reviews` }}:</span>
    <span class="text-lg font-semibold" :class="countColor">{{ count }}</span>
    <div v-if="showStars" class="flex items-center">
      <v-icon 
        v-for="n in 5" 
        :key="n" 
        small 
        :color="n <= starRating ? 'amber darken-1' : 'grey lighten-2'"
      >
        mdi-star
      </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewStarsDisplay',
  props: {
    starRating: {
      type: Number,
      required: true
    },
    count: {
      type: [Number, String],
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    showStars: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    countColor() {
      if (this.starRating <= 2) return 'text-red-600';
      if (this.starRating === 3) return 'text-orange-500';
      if (this.starRating >= 4) return 'text-green-600';
      return 'text-gray-700';
    }
  }
};
</script>

<style scoped>
/* Scoped styles */
</style> 